<template lang="html">
	<div class="container-fluid p-5">
		<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">
						<h6>ဆိုင်ခွဲ ထည့်ရန် <small>(Fields in red are required)</small></h6>
					</div>
					<div class="card-body">
						<form v-on:submit.prevent="onSubmit">
							<div class="form-group row">
								<label for="inputName" class="col-sm-2 col-form-label text-danger">ဆိုင်ခွဲ နာမည်</label>
								<div class="col-sm-10">
									<input type="text" v-model="shopRequest.name" @blur="validationRule()"
										class="form-control" id="inputName">
									<small class="text-danger">{{validationData.name}}</small>
								</div>
							</div>

							<div class="form-group row">
								<label for="inputSlug" class="col-sm-2 col-form-label text-danger">ဆိုင်ခွဲ ကုဒ်နံပါတ်</label>
								<div class="col-sm-10">
									<input type="text" v-model="shopRequest.slug" @blur="validationRule()"
										class="form-control" id="inputSlug">
									<small class="text-danger">{{validationData.slug}}</small>
								</div>
							</div>

							<div class="form-group row">
								<label for="inputRemainPrice" class="col-sm-2 col-form-label">လက်ကျန် ငွေ</label>
								<div class="col-sm-10">
									<input type="text" v-model="shopRequest.remainPrice" @blur="validationRule()"
										class="form-control" id="inputRemainPrice">
								</div>
							</div>

							<div class="form-group row">
								<label for="inputRemainDate" class="col-sm-2 col-form-label">လက်ကျန် ရက်စွဲ</label>
								<div class="col-sm-10">
									<input type="date" v-model="shopRequest.remainDate" @blur="validationRule()"
										class="form-control" id="inputRemainDate">
								</div>
							</div>

							<!-- <div class="form-group row">
								<label for="inputRemainPriceA" class="col-sm-2 col-form-label">ဆိုင်ခွဲA လက်ကျန် ငွေ</label>
								<div class="col-sm-10">
									<input type="text" v-model="shopRequest.remainPriceA" @blur="validationRule()"
										class="form-control" id="inputRemainPriceA">
								</div>
							</div>

							<div class="form-group row">
								<label for="inputRemainDateA" class="col-sm-2 col-form-label">ဆိုင်ခွဲA လက်ကျန် ရက်စွဲ</label>
								<div class="col-sm-10">
									<input type="date" v-model="shopRequest.remainDateA" @blur="validationRule()"
										class="form-control" id="inputRemainDateA">
								</div>
							</div>

							<div class="form-group row">
								<label for="inputRemainPriceB" class="col-sm-2 col-form-label">ဆိုင်ခွဲB လက်ကျန် ငွေ</label>
								<div class="col-sm-10">
									<input type="text" v-model="shopRequest.remainPriceB" @blur="validationRule()"
										class="form-control" id="inputRemainPriceB">
								</div>
							</div>

							<div class="form-group row">
								<label for="inputRemainDateB" class="col-sm-2 col-form-label">ဆိုင်ခွဲB လက်ကျန် ရက်စွဲ</label>
								<div class="col-sm-10">
									<input type="date" v-model="shopRequest.remainDateB" @blur="validationRule()"
										class="form-control" id="inputRemainDateB">
								</div>
							</div> -->

							<button type="submit" class="btn btn-primary float-save">လုပ်ဆောင်မည်</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="js">
	import {
		mapState,
		mapActions
	} from 'vuex'
	import env from '../../enviorments'
	import Loading from 'vue-loading-overlay'
	import 'vue-loading-overlay/dist/vue-loading.css';
	export default {
		name: 'shopCreate',
		components: {
			Loading
		},
		data() {
			return {
				env,
				isLoading: false,
				fullPage: true,
				shopRequest: {
					name: "",
					slug: "",
					remainPrice: "",
					remainDate: "",
					remainPriceA: "",
					remainDateA: "",
					remainPriceB: "",
					remainDateB: "",
				},
				validationData: {
					name: "",
					slug: "",
				}
			}
		},
		watch: {
			async $route(to, from) {
				if (to.params.id) {
					this.shopRequest.id = to.params.id
					await this.shopDetail()
				}
			},
		},
		computed: {},
		methods: {
			...mapActions({
				shopStoreAction: 'shopStoreAction',
			}),
			async onSubmit() {
				this.isLoading = true
				let validation = this.validationRule()
				if (validation == true) {
					this.isLoading = false
					return
				}
				let option = {
					name: this.shopRequest.name,
					slug: this.shopRequest.slug,
					remainPrice: this.shopRequest.remainPrice,
					remainDate: this.shopRequest.remainDate,
					remainPriceA: this.shopRequest.remainPriceA,
					remainDateA: this.shopRequest.remainDateA,
					remainPriceB: this.shopRequest.remainPriceB,
					remainDateB: this.shopRequest.remainDateB
				}
				await this.shopStoreAction({
					...option
				}).then(res => {
					this.$router.replace({ path: 'shop-list', query: { page: 1, reverse: 'desc', sort: 'created_at', name: ''} }).catch(()=>{})
					this.isLoading = false;
				}).catch(err => this.isLoading = true)
			},
			validationRule() {
				let isValidation = []
				if (this.shopRequest.name == "") {
					this.validationData.name = "ဆိုင်ခွဲ ဖြည့်ပါ။"
					isValidation.push(true)
				} else {
					this.validationData.name = ""
					isValidation.push(false)
				}
				if (this.shopRequest.slug == "") {
					this.validationData.slug = "ဆိုင်ခွဲ ကုဒ်နံပါတ် ဖြည့်ပါ။"
					isValidation.push(true)
				} else {
					this.validationData.slug = ""
					isValidation.push(false)
				}
				if (isValidation.includes(true)) {
					return true
				} else {
					return false
				}
			}
		},
		async mounted() {
		}
	}
</script>

<style scoped lang="scss">
	.v-text-field--box .v-input__slot,
	.v-text-field--outline .v-input__slot {
		min-height: 56px;
	}
	.banner-image {
		width: 100px;
		height: 100px;
		object-fit: contain;
	}
</style>